module.exports = __webpack_public_path__ + "static/media/sSellOpt.99014e0d.png";